/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { TenantContext } from '@jira/platform__tenant-context-types/src/tenant-context.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import {
	createContainer,
	createHook,
	createSubscriber,
	type BoundActions,
	type HookFunction,
	type OverrideContainerComponent,
	type SubscriberComponent,
} from '@atlassian/react-sweet-state';
import * as actions from '../../actions/index.tsx';
import Store from '../../store.tsx';
import type { Actions, ContainerProps, State } from '../../types.tsx';

export const TenantContextContainer: OverrideContainerComponent<ContainerProps> = createContainer<
	State,
	Actions,
	ContainerProps
>(Store, {
	onInit:
		() =>
		({ dispatch }) =>
			dispatch(actions.bootstrap()),
});

export const TenantContextSubscriber: SubscriberComponent<
	State,
	BoundActions<State, Actions>,
	unknown
> = createSubscriber<State, Actions>(Store, {
	displayName: 'TenantContextSubscriber',
});

/**
 * @deprecated use individual hooks for the specific things you want.
 * @see module:allTenantContextHooks
 */
export const useTenantContextHook: HookFunction<
	State,
	BoundActions<State, Actions>,
	void
> = createHook(Store);

/**
 * @deprecated use individual hooks for the specific things you want.
 * @see module:allTenantContextHooks
 * @agent-skills: tenant-context
 */
export const useTenantContext = (): TenantContext => {
	const [{ tenantContext }] = useTenantContextHook();

	return tenantContext;
};
